const en = require('./en');
const es = require('./es');
const pt = require('./pt');
const eu = require('./eu');
const fr = require('./fr');
const he = require('./he');
const nl = require('./nl');
const ca = require('./ca');
const it = require('./it');
const cy = require('./cy');
const de = require('./de');
const ga = require('./ga');
const ast = require('./ast');
const nn = require('./nn');
const sv = require('./sv');
const sco = require('./sco');
const ar = require('./ar');
const oc = require('./oc');
const gl = require('./gl');
const co = require('./co');
const da = require('./da');
const br = require('./br');

module.exports = new Set([
  en,
  nl,
  de,
  nn,
  sv,
  es,
  ca,
  ast,
  pt,
  oc,
  gl,
  co,
  fr,
  da,
  it,
  eu,
  ga,
  cy,
  sco,
  he,
  ar,
  br,
]);
